import { FC } from "react";
import Link from "next/link";
import { Product } from "@prisma/client";
import { useTranslation } from "next-i18next";

import ResponsiveSlider from "@components/common/responsive-slider";
import ProductImage from "@components/common/product-image";

interface Props {
  products: Product[];
}

const RecentlyViewedProducts: FC<Props> = ({ products }) => {
  const { t } = useTranslation("product");

  return products.length > 0 ? (
    <div className="flex flex-col w-full space-y-4 pb-6">
      <h4 className="text-lg font-semibold pl-4 mt-4 text-black">
        {t("recent")}
      </h4>
      <ResponsiveSlider
        breakpoints={{
          xxl: 10,
          xl: 8,
          lg: 7,
          md: 6,
          sm: 5,
          base: 3,
        }}
        settings={{ className: "not-centered-slider" }}
      >
        {products.map((product) => (
          <div key={product.id} className="px-2">
            <Link
              href={{
                pathname: "/products/[slug]",
                query: { slug: product.slug },
              }}
            >
              <a>
                <ProductImage
                  {...{
                    photo: product.featuredPhoto,
                    highlightPhoto: product.featuredPhotoHighlight,
                    productId: product.id,
                    name: product.name,
                    slug: product.slug,
                  }}
                />
              </a>
            </Link>
          </div>
        ))}
      </ResponsiveSlider>
    </div>
  ) : null;
};

export default RecentlyViewedProducts;
